// TODO: Move to WebApp
export const SUPPORTED_DEVICES = [
  {
    id: "TC3",
    imageUrl: "tc3_mounted.jpg",
    name: "TC-3 Device (2022)",
  },
  {
    id: "FC2",
    imageUrl: "fc2Pro.png",
    name: "FC-2 Device (2021-2022)",
  },
  {
    id: "solar-panel",
    imageUrl: "solar-panel.png",
    name: "Solar Panel",
  },
  {
    id: "PC1",
    imageUrl: "pc_1_mounted.png",
    name: "Legacy Products (PC-1 Devices)",
  },
] as const

const FC_2_FILES = {
  "device-overview": "../../../markdown/fc2-device-overview.md",
  "in-the-box": "../../../markdown/fc2-in-the-box.md",
  "pump-hardware-installation":
    "../../../markdown/fc2-pump-hardware-installation.md",
  "reel-hardware-installation":
    "../../../markdown/fc2-reel-hardware-installation.md",
  "troubleshooting": "../../../markdown/fc2-troubleshooting.md",
}
const PC1_FILES = {
  "device-overview": "../../../markdown/pc1-device-overview.md",
  "in-the-box": "../../../markdown/pc1-in-the-box.md",
  "pump-hardware-installation":
    "../../../markdown/pc1-pump-hardware-installation.md",
  "reel-hardware-installation":
    "../../../markdown/pc1-reel-hardware-installation.md",
}
const TC3_FILES = {
  "device-overview": "../../../markdown/tc3-device-overview.md",
  "electric-pump": "../../../markdown/tc3-electric-pump-installation.md",
  "flowmeter": "../../../markdown/tc3-flowmeter.md",
  "in-the-box": "../../../markdown/tc3-in-the-box.md",
  "pump-hardware-installation":
    "../../../markdown/tc3-pump-hardware-installation.md",
  "reel-hardware-installation":
    "../../../markdown/tc3-reel-hardware-installation.md",
  "troubleshooting": "../../../markdown/tc3-troubleshooting.md",
}
const SOLAR_FILES = {
  "device-overview": "../../../markdown/solar-panel-device-overview.md",
}
export const SUPPORT_PRODUCT_TO_FILE_MAP = {
  "FC2": FC_2_FILES,
  "PC1": PC1_FILES,
  "TC3": TC3_FILES,
  "solar-panel": SOLAR_FILES,
} as const

export type SupportTopicId =
  | keyof typeof FC_2_FILES
  | keyof typeof PC1_FILES
  | keyof typeof SOLAR_FILES
  | keyof typeof TC3_FILES
  | "print-all"

export type SupportProductId = keyof typeof SUPPORT_PRODUCT_TO_FILE_MAP
